module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (190).95ecf441.jpg";